import React, { useEffect, useRef, useState } from "react";
import { History, Gauge, ClipboardCheck, Wrench, FolderCheck, ShieldCheck } from "lucide-react";
import { VERIFICATION } from "../mock";

const ICONS = [History, Gauge, ClipboardCheck, Wrench, FolderCheck, ShieldCheck];

export default function Verification() {
  const pathRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = pathRef.current;
    if (!el) return undefined;
    const ob = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); ob.disconnect(); } },
      { threshold: 0.2 }
    );
    ob.observe(el);
    return () => ob.disconnect();
  }, []);

  return (
    <section id="verifica" className="cm-reveal py-24 lg:py-32">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.9fr_1.3fr] lg:gap-20">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <p className="label-mono mb-6">01 — La verifica Carmaps</p>
            <h2 className="h-display text-[clamp(2.1rem,4.2vw,3.4rem)]">
              Un'auto su Carmaps è più di un annuncio.
            </h2>
            <p className="mt-7 max-w-[430px] text-[1.02rem] leading-relaxed text-[#5b5b54]">
              È una vettura che si è spogliata e messa a nudo di fronte a noi
              per essere ispezionata. Con noi scegli certificazione dello stato
              di utilizzo attuale, verifiche della provenienza, velocità nella
              consegna a casa e garanzia post vendita.
            </p>
            <p className="mt-8 font-mono-cm text-[0.72rem] uppercase tracking-[0.14em] text-[var(--cm-green)]">
              5 controlli · un solo percorso
            </p>
          </div>

          <ol
            ref={pathRef}
            className={`cm-vpath${inView ? " cm-vpath-in" : ""}`}
            data-testid="verification-path"
          >
            {VERIFICATION.map((v, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <li
                  key={v.n}
                  className="cm-vstep"
                  style={{ transitionDelay: `${i * 110}ms` }}
                >
                  <span className="cm-vnode" aria-hidden="true">
                    <Icon size={17} className="cm-vnode-icon" />
                    <span className="cm-vnode-num">{v.n}</span>
                  </span>
                  <div className="cm-vbody">
                    <h3 className="text-[1.15rem] font-semibold">{v.title}</h3>
                    <p className="mt-2 text-[0.92rem] leading-relaxed text-[#6f6f68]">
                      {v.text}
                    </p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
